import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CheckCircleDotted = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "check-circle-dotted",
    className: clsx('stroke-current', className),
    width: "100%",
    height: "100%"
  }, props, {
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_6014_42835)",
      children: /*#__PURE__*/_jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m7.5 12 3 3 6-6M10 2.2l.0388-.0078a10.0006 10.0006 0 0 1 3.9224 0L14 2.2m0 19.6-.0388.0078a10.0013 10.0013 0 0 1-3.9224 0L10 21.8M2.2 14l-.0078-.0388a10.0006 10.0006 0 0 1 0-3.9224L2.2 10m19.6 0 .0078.0388a10.0013 10.0013 0 0 1 0 3.9224L21.8 14M17.5172 3.5829l.033.022a10.001 10.001 0 0 1 2.7735 2.7734l.0219.033m-16.7628.0715.022-.033a10 10 0 0 1 2.7735-2.7735l.033-.022m11.0001 16.8629.0329-.022a9.9966 9.9966 0 0 0 2.7735-2.7735l.022-.0329m-16.6569-.2717.022.033a10.001 10.001 0 0 0 2.7735 2.7735l.033.0219"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_6014_42835",
        children: /*#__PURE__*/_jsx("path", {
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
};
export default CheckCircleDotted;